export default __webpack_public_path__ + "static/media/Workflow Header.3391b3bf.png";